/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles'
import { VIconBtn } from 'vuetify/labs/VIconBtn'
import { VHotkey } from 'vuetify/labs/VHotkey';
// Composables
import { createVuetify } from 'vuetify'
import { aliases, fa } from 'vuetify/iconsets/fa-svg'

const myCustomTheme = {
  dark: false,
  colors: {
    primary: '#5F0F40',
    secondary: '##0099CC',
    accent: '#E36414',
    info: '#03c9d7',
    success: '#00c853',
    warning: '#FB8B24',
    error: '#9A031E',
  }
};
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
    },
  },
  theme: {
    defaultTheme: 'myCustomTheme',
    themes: {
      myCustomTheme,
    }
  },
  components: {
    VHotkey,
    VIconBtn
  },
  defaults: {
    VBtn: {
      color: 'primary',
      style: '--fa-secondary-color: #ffffff; --fa-secondary-opacity: 1'
    },
    VBtnGroup: {
      density: 'compact',
      variant: 'text',
      color: 'primary'
    },
    VCard: {
      rounded: 'lg',
      variant: 'tonal',
    },
    VCardActions: {
      VBtn: {
        color: 'secondary',
        style: '--fa-secondary-color: #ffffff; --fa-secondary-opacity: 1'
      }
    },

    VCarousel: {
      hideDelimiters: true,
      progress: 'secondary',
    },
    VCarouselItem: {
      class: 'pa-0',
      cover: true
    },

    VChip: {
      variant: 'outlined',
      color: 'primary',
      density: 'compact',
      label: true,
      class: 'ma-1'
    },

    VDataTable: {
      density: 'compact',
      sortAscIcon: 'fa-sharp-duotone fa-arrow-down-short-wide',
      sortDescIcon: 'fa-sharp-duotone fa-arrow-down-wide-short',
      firstIcon: 'fa-sharp-duotone fa-chevrons-left',
      lastIcon: 'fa-sharp-duotone fa-chevrons-right',
      prevIcon: 'fa-sharp-duotone fa-angle-left',
      nextIcon: 'fa-sharp-duotone fa-angle-right',
      showCurrentPage: true,
      hover: true,
      VBtn: {
        color: 'primary',
        variant: 'plain'

      }
    },
    VIcon: {
      // style: '--fa-sharp-duotone fa-secondary-opacity: 0.6;'
      style: '--fa-sharp-duotone; --fa-secondary-color: #ffffff; --fa-secondary-opacity: 1'
    },
    VIconBtn: {
      color: 'primary',
      variant: 'text',
      activeColor: 'accent',
    },
    VHotkey: {
      displayMode: 'symbol'
    },

    VMenu: {
      location: 'bottom',
      transition: 'slide-y-transition'
    },

    VNavigationDrawer: {
      left: true,
      temporary: true,
      width: '600',
    },
    VNumberInput: {
      variant: 'solo',
      controlVariant: 'split',
      flat: 'true',

    },
    VSelect: {
      menuIcon: 'fa-sharp-duotone fa-angle-down'
    },

    VSheet: {
      rounded: 'lg',
      border: 'md'
    },

    VTextField: {
      color: 'primary',
      density: 'compact',
      border: 'md',
      variant: 'outlined',
      rounded: 'lg',
      clearIcon: 'fa-sharp-duotone fa-circle-xmark',
      class: 'ma-2',

    },
    VToolbar: {
      rounded: 'lg',
      density: 'compact',
      border: 'md',
      VBtn: {
        tile: true,
        color: 'primary',
        size: 'small'
      }
    },

    VTooltip: {
      openOnHover: true,
      location: 'bottom',
      activator: 'parent'
    }
  }
})
